import { SVGProps } from 'react';

const SvgSushi = (props: SVGProps<SVGSVGElement>) => {
	return (
		<svg viewBox='0 0 24 24' className='svg-icon' {...props}>
			<g fill='none' fillRule='evenodd'>
				<path d='M0 0h24v24H0z' />
				<path
					d='M7 17c2.281 0 4-1.031 4-2 0-.969-1.719-2-4-2-2.281 0-4 1.031-4 2 0 .969 1.719 2 4 2zm4.5 4.31C10.69 22.31 8.98 23 7 23c-2.761 0-5-1.343-5-3v-5c0-1.657 2.239-3 5-3 1.98 0 3.69.69 4.5 1.69.81-1 2.52-1.69 4.5-1.69 2.761 0 5 1.343 5 3v5c0 1.657-2.239 3-5 3-1.98 0-3.69-.69-4.5-1.69zM16 17c2.281 0 4-1.031 4-2 0-.969-1.719-2-4-2-2.281 0-4 1.031-4 2 0 .969 1.719 2 4 2z'
					fill='currentColor'
				/>
				<path
					d='M19.66 2.021a.974.974 0 01-.627 1.246L2.336 8.53a.513.513 0 01-.334-.97l16.397-6.133a.974.974 0 011.262.595zm1.312 4.53a.974.974 0 01-.816 1.133L2.842 10.27a.513.513 0 01-.179-1.011l17.155-3.493a.974.974 0 011.154.786zM16 16c-.828 0-1.5-.448-1.5-1s.672-1 1.5-1 1.5.448 1.5 1-.672 1-1.5 1zm-9 0c-.828 0-1.5-.448-1.5-1s.672-1 1.5-1 1.5.448 1.5 1-.672 1-1.5 1z'
					fill='currentColor'
					opacity={0.3}
				/>
			</g>
		</svg>
	);
};

export default SvgSushi;
